export default __webpack_public_path__ + "static/media/katalog-2021-eng.08fafd0a.pdf";